import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "alert2--sprite",
  "use": "alert2--sprite-usage",
  "viewBox": "0 0 43 42",
  "content": "<symbol viewBox=\"0 0 43 42\" xmlns=\"http://www.w3.org/2000/svg\" id=\"alert2--sprite\">\n<rect x=\"0.5\" y=\"0.5\" width=\"42\" height=\"41\" rx=\"20.5\" fill=\"currentColor\" />\n<path d=\"M29.5 11H13.5C12.4 11 11.5 11.9 11.5 13V31L15.5 27H29.5C30.6 27 31.5 26.1 31.5 25V13C31.5 11.9 30.6 11 29.5 11ZM29.5 25H14.67L13.5 26.17V13H29.5V25ZM20.5 21H22.5V23H20.5V21ZM20.5 15H22.5V19H20.5V15Z\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol